export default __webpack_public_path__ + "static/media/right-learning-potential-new.fe129b92.png";